<template>
    <div class="address-list-warp">
        <AddressList 
        v-model="chosenAddressId"
        :switchable="false"
        :list="list"
        :disabled-list="disabledList"
        default-tag-text="默认"
        @click-item="setAddress"
        @add="onAdd"
        @edit="onEdit"/>
    </div>
</template>
<script>
import { AddressList } from 'vant';
import { addressesList } from '../api/index.js'
export default {
    components: { AddressList },
    data () {
        return {
            chosenAddressId: '1',
            list: [],
            disabledList: [],
            isEdit: false,
            checkMode: ''
        }
    },
    activated() {
        this.getAddressesList()
        this.checkMode = this.$route.query.from
    },
    mounted() {
    },
    methods: {
        onAdd() {
            this.$router.push({path: '/addressDetail'})
        },
        onEdit(e) {
            e.addressDetail = e.shortAddress
            window.localStorage.setItem('editAddress', JSON.stringify(e))
            this.isEdit = true
            this.$router.push({path: '/addressDetail'})
        },
        setAddress(e) {
            setTimeout(() => {
                if(this.isEdit) {
                    this.isEdit = false
                    return
                }
                if (this.checkMode) {
                    this.selectedAddress = e
                    this.$EventBus.$emit('selectedAddress', this.selectedAddress)
                    this.$router.go(-1)
                }
            },100)
        },
        getAddressesList () {
            addressesList().then(res => {
                console.log(res)
                let list = res.data || []
                list.forEach(element => {
                    element.tel = element.phone_number
                    element.shortAddress = element.address
                    element.address = element.province + element.city + element.district + element.shortAddress
                    element.isDefault = element.default_flag == 2 ? true : false
                });
                this.list = res.data || []
            })
        },
    }
}
</script>
<style lang="sass" scoped>

</style>

